import Loader from "components/Loader";
import React from "react";
interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}
const CustomButton: React.FC<IProps> = ({
  onClick = () => {},
  type = "button",
  title,
  isLoading = false,
  className,
}) => {
  return (
    <div>
      <button
        onClick={onClick}
        disabled={isLoading}
        type={type}
        className={`${
          isLoading
            ? "bg-disabled text-disabled flex items-center justify-center cursor-not-allowed"
            : "bg-green text-white cursor-pointer rounded-md hover:bg-[#15803d] text-md"
        } font-bold py-2 px-2 w-full mt-1 hover:px-4 hover:py-3 hover:transition-all ${className}`}
      >
        {isLoading && <Loader />}
        {title}
      </button>
    </div>
  );
};

export default CustomButton